'use client';

import Hamburger from '~/components/Chrome/Header/Mobile/Hamburger';
import { useMobileNav } from '~/contexts/MobileNavContext';

export default function AppDirMobileLeftNavButton() {
  const { toggleNav } = useMobileNav();

  return (
    <button
      onClick={toggleNav}
      aria-label="Open navigation to search categories, terms, and more."
    >
      <Hamburger />
    </button>
  );
}
